const cards = [
  {
    title: '红桃视频 · 品质剧场',
    desc: '精选国内外高分剧集，涵盖悬疑、都市、古装等多元类型，每日更新热播内容，让追剧不再等待。红桃视频以制作精良著称，画质清晰流畅。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20drama%20scene%20with%20peach%20and%20coral%20tones%2C%20elegant%20theater%20atmosphere%2C%20soft%20dramatic%20lighting%2C%20film%20grain%20texture%2C%20no%20faces%2C%20sophisticated%20composition&width=800&height=500&seq=card-01-bale&orientation=landscape',
    tag: '品质保证',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    title: '樱花视频 · 独家好剧',
    desc: '樱花视频以独家版权和自制内容见长，汇聚众多热门IP改编作品。从都市情感到古风传奇，每一部都值得细细品味，高清画质带来沉浸式观感。',
    img: 'https://readdy.ai/api/search-image?query=Soft%20pink%20cherry%20blossom%20cinematic%20atmosphere%2C%20romantic%20drama%20mood%2C%20gentle%20lighting%20with%20petal%20texture%2C%20elegant%20composition%2C%20film%20aesthetic%2C%20no%20faces&width=800&height=500&seq=card-02-bale&orientation=landscape',
    tag: '独家内容',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    title: '糖豆视频 · 快乐源泉',
    desc: '糖豆视频主打轻松娱乐内容，短剧、综艺、搞笑片段一应俱全。竖屏沉浸式体验，碎片时间也能畅快观看，是您的日常快乐源泉。',
    img: 'https://readdy.ai/api/search-image?query=Bright%20energetic%20entertainment%20atmosphere%20with%20warm%20golden%20and%20dark%20tones%2C%20playful%20abstract%20composition%2C%20colorful%20bokeh%20lights%2C%20fun%20vibe%2C%20no%20faces%2C%20dynamic%20mood&width=800&height=500&seq=card-03-bale&orientation=landscape',
    tag: '轻松娱乐',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    title: '聚合搜索 · 一站直达',
    desc: '芭乐视频聚合红桃视频、樱花视频、糖豆视频等多个平台，智能推荐热门内容。无需切换App，一站搜索全网影视资源，节省您的时间。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20search%20interface%20atmosphere%20with%20warm%20coral%20and%20dark%20tones%2C%20abstract%20data%20visualization%20style%2C%20clean%20minimalist%20composition%2C%20soft%20glow%2C%20no%20text%2C%20tech%20aesthetic&width=800&height=500&seq=card-04-bale&orientation=landscape',
    tag: '便捷高效',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    title: '高清流畅 · 不缓冲',
    desc: '采用智能CDN加速和多线路冗余技术，确保高清画质下的流畅播放体验。无论网络环境如何，都能享受不卡顿的观影过程，让您沉浸在剧情之中。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20high%20speed%20streaming%20atmosphere%20with%20teal%20and%20dark%20tones%2C%20abstract%20light%20trails%2C%20smooth%20motion%20blur%20effect%2C%20futuristic%20yet%20elegant%2C%20no%20text%2C%20dynamic%20composition&width=800&height=500&seq=card-05-bale&orientation=landscape',
    tag: '技术保障',
    tagColor: 'bg-accent-100 text-accent-700',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">精选推荐</span>
          <h2 className="mt-2 text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            精选推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500">为您精选各大特色平台的优势内容</p>
        </div>

        <div className="space-y-8">
          {cards.map((card, idx) => (
            <a
              key={idx}
              href={idx < 3 ? '#index' : '#about'}
              className={`group flex flex-col md:flex-row gap-6 p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                idx % 2 === 1 ? 'md:flex-row-reverse' : ''
              }`}
            >
              <div className="md:w-[280px] shrink-0">
                <div className="aspect-[16/10] rounded-xl overflow-hidden bg-background-200">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="flex-1 flex flex-col justify-center">
                <span className={`self-start px-2.5 py-0.5 rounded-full text-xs font-medium mb-3 ${card.tagColor}`}>
                  {card.tag}
                </span>
                <h3 className="text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  {card.desc}
                </p>
                <span className="inline-flex items-center gap-1 mt-4 text-sm font-medium text-primary-600 group-hover:gap-2 transition-all whitespace-nowrap">
                  了解更多
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}